import { getExamListApi } from "@/api/services/admin/learning-content";
import { QUERY_KEYS } from "@/constants/queryKeys";
import { useQuery } from "@tanstack/react-query";

/**
 * Custom hook for fetching exam list for an industry with pagination
 */
export const useExamList = (industryId: number | string | undefined, page = 1, perPage = 5) => {
  const isValidId = !!industryId && !isNaN(Number(industryId));

  const query = useQuery({
    queryKey: [QUERY_KEYS.LEARNING_CONTENT.FETCH_EXAM_LIST, industryId, page, perPage],
    queryFn: () => getExamListApi({ industryId: Number(industryId), page, perPage }),
    enabled: isValidId,
  });

  return {
    data: query.data,
    isLoading: query.isLoading,
    isFetching: query.isFetching,
    isError: query.isError,
    error: query.error,
    refetch: query.refetch,
  };
};
